/**
 * Mirror of fides-capital-native-app/src/theme/colors.ts for CI/type-check when the
 * native app repo is not checked out. Keep in sync with the native app theme file.
 */
export const colors = {
  primary: '#143c34',
  primaryDark: '#123833',
  primaryDarker: '#0e2a24',
  background: '#f3f5f8',
  surface: '#FFFFFF',
  surfaceVariant: '#f1f4f8',
  surfaceDeep: '#0f172a',
  surfaceSage: '#c2d4bd',
  text: '#113833',
  textOnPrimary: '#ffffff',
  textSecondary: '#667085',
  textMuted: '#6c7e6b',
  buttonBg: '#143c34',
  buttonText: '#ffffff',
  accentLightButton: '#a1ba94',
  buttonSecondaryBg: '#a1ba94',
  buttonSecondaryText: '#123833',
  border: '#98a2b3',
  borderLight: '#d0d5dd',
  error: '#a73232',
  errorBackground: '#fbeaea',
  errorContainer: '#ffebee',
  overdue: '#d4061a',
  dueSoon: '#856404',
  dueSoonBackground: '#fff3cd',
  dueNear: '#0c5460',
  dueNearBackground: '#d1ecf1',
  success: '#4CAF50',
  warning: '#f9a825',
  warningBackground: '#fff8e1',
  info: '#003366',
  premiumGold: '#B88A44',
  headerBackground: '#ffffff',
  headerTint: '#113833',
  avatarBackground: '#123833',
  avatarText: '#ffffff',
  chart: {
    blue: '#5881A0',
    red: '#A85551',
    green: '#8B995F',
    purple: '#74538C',
    orange: '#C6844E',
    teal: '#498E82',
    primaryLine: '#1E7F6C',
  },
  burntOrange: '#C45C26',
};

export const graphColorPalette: string[] = [
  '#5881A0',
  '#A85551',
  '#8B995F',
  '#74538C',
  '#C6844E',
  '#498E82',
];
